import { render, staticRenderFns } from "./SelectorPage.vue?vue&type=template&id=6f28aa63"
import script from "./SelectorPage.vue?vue&type=script&lang=js"
export * from "./SelectorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports